export { default } from "./OtpWrapper.jsx";
